<div class="file-info-panel-main create-link-panel-main modal-popup" [ngStyle]="{'display': showEnhancedShareLink ? 'block' : 'none'}">
  <header>
    <div class="mini-thumb-details create-link-header border-0 pb-0">
      <span class="NeueExit-Folder d-lg-block d-md-none mr-2 float-left" (click)="confirmDiscard()"></span>
      <!--<span data-brackets-id="18680" class="float-left"><img data-brackets-id="18681" src="images/mini-thumb.jpg"></span>-->
      <!-- <span class="float-left pt-3 d-lg-block">Create Link</span> -->
      <span class="d-lg-block share-link-title">{{pageModalHeader}}</span>
      <!-- <span data-brackets-id="18682" class="float-left d-lg-none pt-3 pl-0"><span class="NeueExit-Folder mr-2"></span>image.jpg</span> -->
      <!-- Close Icon -->
      <div class="icon-close float-right mt-3 d-none d-lg-block" (click)="confirmDiscard()">esc<span class="Neueclosefilled pl-1"></span></div>
    </div>
  </header>

  <!-- Create Link Section -->
  <div class="create-link-main mt-2">
    <!-- Create Link -->
    <div class="create-link-block">
      <label class="txt-link-name d-block">Link Name</label>
      <span class="NeueLink"></span>
      @if (universalService.isUserOnSharedLinkByMe) {
        <label for="linkName" style="padding-left: 5px;">{{defaultCurrentDateForTitle}}</label>
      }
      @if (!universalService.isUserOnSharedLinkByMe) {
        <input type="text" value="{{defaultCurrentDateForTitle}}" maxlength="64" class="" id="linkName" (keyup)="onLinkNameChange();">
      }
      @if (!universalService.isUserOnSharedLinkByMe) {
        <p class="name-error">Length should be between 2-64 characters. Valid characters include letters(A-Z/a-z), numbers(0-9), spaces, hyphens(-), or underscores(_).The name should start and end with letters/number.</p>
      }
    </div>
    <!-- Access Controls -->
    @if (showFamilyShare) {
      <div class="access-controls-main">
        <h2>Access controls</h2>
        @if (!isAccessControlAllowed) {
          <p>Available for the premium user and all family share members-only <a href="javascript:void(0)" (click)="buyStorageDetails()" rel="noopener noreferrer">Buy Storage</a></p>
        }
        <!-- Access Config - Set Expiry / Password -->
        <div class="access-config mt-3" [ngClass]="!isAccessControlAllowed ? 'disabled' : ''">
          <!-- <div class="access-config mt-3" > -->
          <div class="row m-0 p-0">
            <div class="col-6 m-0 p-0">
              <span class="NeueDate-modified mr-2"></span>
              <span class="txt-expiry">Set expiry</span>
              <!-- <span class="date">{{defaultExpiryDate}}</span> -->
            </div>
            <div class="col-6 m-0 p-0 text-right position-relative">
              <form>
                <div class="sd-container">
                  <input class="sd" type="date" name="selected_date" id="link-expiry" min='{{minDateSelection}}' (keydown)="discardCalendarKeyInput()" (input)="setExpiryChange($event)" value='{{selExpiryDate}}' [formControl]="dateControl" maxlength="10" />
                  <span class="open-button">
                    <button type="button" class="Neuecalenderfilled"></button>
                  </span>
                </div>
              </form>
              <!-- <input type="date" id="link-expiry" min='{{minDateSelection}}' (keydown)="discardCalendarKeyInput()" (change)="setExpiryChange($event)" value='{{selExpiryDate}}'> -->
            </div>
          </div>
          <div class="row m-0 mt-2 p-0">
            <div class="col-6 m-0 p-0 pt-2">
              <span class="Neuelock_line mr-1"></span>
              <span class="txt-expiry">Set password</span>
            </div>
            <div class="col-6 m-0 p-0 text-right">
              <!-- Password Toggle Switch -->
              <div class="switch">
                <input type="checkbox" id="passwordToggle" (click)="enablePasswordField()" />
                <label for="passwordToggle"></label>
              </div>
            </div>
            <!-- Set Password -->
            @if (isPasswordFieldEnabled) {
              <div class="set-password-block mt-3 ml-4">
                <div class="pswd-cont mb-2">
                  <input type="password" class="pswd-input" id="linkPass" (keyup)="onPasswordChange()" autocomplete="off">
                  @if (!showPasswordData) {
                    <span class="NeuePassword-Show" (click)="showPasswordContent('show')"></span>
                  }
                  @if (showPasswordData) {
                    <span class="NeuePassword-Hide" (click)="showPasswordContent('hide')"></span>
                  }
                </div>
                <p class="password-error">Password can include letters (A-Z, a-z) and numbers (0-9)</p>
                <p class="password-error">Password should not contain any space</p>
                <p class="password-error">Password length should be between 6 to 10 characters</p>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <!-- Footer -->
    <footer class="create-link-panel-footer">
      <!-- Footer Buttons -->
      <!-- SAVE -->
      @if (isEditModeOn) {
        <div class="btn-wrap">
          <p>Please save the changes to enable copy and share link options.</p>
          <button class="btn btn-save" (click)="saveAccessDetails()" [disabled]="!isValidPasswordInput || !isValidNameInput">Save</button>
        </div>
      }
      <!-- COPY/SHARE LINK -->
      @if (!isEditModeOn) {
        <div class="btn-wrap pb-3">
          <a href="javascript:void(0)" rel="noopener noreferrer" class="btn btn-copy-link" (click)="copyShareLink()">{{copyText}}</a>
          <button class="btn btn-share-link ml-4" (click)="shareUniversalLink()">Share Link</button>
        </div>
      }
    </footer>
  </div>
  <!-- Create Link Section ends -->


  <!-- <div class="spinner_loader">
  <div class="small_loader"></div>
</div> -->

</div>